// frontend/src/components/SyntaxHighlighter.tsx
import React from "react";
import { Prism as SyntaxHighlighterLib } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface SyntaxHighlighterProps {
  code: string;
  language?: string;
  className?: string;
}

export const SyntaxHighlighter: React.FC<SyntaxHighlighterProps> = ({
  code,
  language = "python",
  className = "",
}) => {
  return (
    <div className={`python-code ${className}`}>
      <SyntaxHighlighterLib
        language={language}
        style={vscDarkPlus}
        customStyle={{
          background: '#1a202c',
          padding: '16px',
          borderRadius: '8px',
          border: '1px solid #2d3748',
          fontSize: '13px',
          lineHeight: '1.5',
          fontFamily: '"SF Mono", "Monaco", "Inconsolata", "Roboto Mono", "Source Code Pro", monospace',
        }}
        showLineNumbers={false}
        wrapLines={true}
        wrapLongLines={true}
      >
        {code}
      </SyntaxHighlighterLib>
    </div>
  );
};
